import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface PersonalInfoStepProps {
  onNext: (data: {
    firstName: string;
    lastName: string;
  }) => void;
  defaultFirstName?: string;
  defaultLastName?: string;
}
export function PersonalInfoStep({
  onNext,
  defaultFirstName = '',
  defaultLastName = ''
}: PersonalInfoStepProps) {
  const [firstName, setFirstName] = useState(defaultFirstName);
  const [lastName, setLastName] = useState(defaultLastName);
  const isValid = firstName.trim().length >= 2 && lastName.trim().length >= 2 && /^[a-zA-Z\s]*$/.test(firstName) && /^[a-zA-Z\s]*$/.test(lastName);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid) {
      onNext({
        firstName: firstName.trim(),
        lastName: lastName.trim()
      });
    }
  };
  return <div className="w-full max-w-md mx-auto px-4 py-1 sm:py-4" data-id="element-170">
      <div className="text-center mb-3 sm:mb-5" data-id="element-171">
        <h2 className="text-xl sm:text-3xl font-bold text-dark mb-1" data-id="element-172">
          ¿Cuál es tu nombre?
        </h2>
        <p className="text-gray-600 text-xs sm:text-sm" data-id="element-173">
          Solo para tu cotización personalizada
        </p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-2.5" data-id="element-174">
        <div data-id="element-175">
          <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1 ml-1" data-id="element-176">
            Nombre
          </label>
          <input type="text" id="firstName" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="Ej. Juan" className="w-full p-3.5 bg-white rounded-lg border-2 border-gray-200 focus:border-primary focus:ring-0 outline-none text-base transition-colors" required data-id="element-177" />
        </div>
        <div data-id="element-178">
          <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1 ml-1" data-id="element-179">
            Apellido
          </label>
          <input type="text" id="lastName" value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Ej. Pérez" className="w-full p-3.5 bg-white rounded-lg border-2 border-gray-200 focus:border-primary focus:ring-0 outline-none text-base transition-colors" required data-id="element-180" />
        </div>
        <motion.button whileHover={{
        scale: isValid ? 1.02 : 1
      }} whileTap={{
        scale: isValid ? 0.98 : 1
      }} type="submit" disabled={!isValid} className="w-full bg-primary hover:bg-primary-hover text-white font-bold text-base py-3.5 px-6 rounded-lg shadow-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-2" data-id="element-181">
          Seguir
        </motion.button>
      </form>
    </div>;
}